import { CatalogSection } from './CatalogSection';

export const VacanciesSection = ({ filterKey }: { filterKey?: string }) => (
  <CatalogSection kind="VACANCY" filterKey={filterKey} />
);
